import { connect } from 'react-redux'
import { compose, withProps, lifecycle, branch, renderComponent } from 'recompose'
import withType from 'components/common/hoc/withType'
import withCheckStoreAndShowStoreLocatorModal from 'components/common/hoc/withCheckStoreAndShowStoreLocatorModal'
import { resetFilters } from 'components/OneColumnSearchResultPage/actions'
import withGBBDetails from 'components/common/hoc/withGBBDetails/withGBBDetails'
import getActiveVehicle from 'selectors/getActiveVehicle'
import { getLocationSearch, getLocationPathname } from 'selectors/getPageLocation'
import { getCurrentStorePhoneNumber } from 'selectors/getCurrentStore'
import { getIsAllCompatible, getSectionsLabel } from '../selectors'
import { checkNoResult, generateStaticLabel } from './helpers'
import {
  isSearchByVehicleUrl,
  isSearchByTrailer,
  isSearchByTireSizeUrl
} from 'helpers/location'
import { isMobile } from 'components/common/Media/helpers'
import BOTSearchResult from './BOTSearchResult'
import NoResultComponent from './NoResultComponent'

const withNoResultComponent = branch(
  ({ isNoResult }) => isNoResult,
  renderComponent(NoResultComponent)
)

const mapStateToProps = (state, props) => {
  const { resultsLabel, compatibilityLabel } = getSectionsLabel(state, props)
  const { app: { isFetching, isLoading, isNavigating } = {}} = state
  const pathname = getLocationPathname(state)

  return {
    isTiresTrailerPage: isSearchByTrailer({ pathname }),
    isBySizePage: isSearchByTireSizeUrl({ pathname }),
    resultsLabel,
    compatibilityLabel,
    preventComponentUpdate: isFetching || isLoading || isNavigating,
    activeVehicle: getActiveVehicle(state),
    isAllCompatible: getIsAllCompatible(state),
    hasFilters: !!(getLocationSearch(state)).length,
    isNoResult: isSearchByVehicleUrl({ pathname }) && checkNoResult(props.rightContent),
    storePhoneNumber: getCurrentStorePhoneNumber(state)
  }
}

const withTotalRecords = withProps(({ rightContent: [{ totalNumRecs } = {}] = []}) => ({
  totalNumRecs
}))

const withRecommendedResultsVisibilityProp = withProps(({ gBBDetails }) => ({
  isRecommendedResultsVisible: Boolean(Object.keys(gBBDetails).length && !isMobile())
}))

const withStaticLabel = withProps(({ rightContent: [{ totalNumRecs } = {}] = [], isTiresTrailerPage }) => {
  const staticLabel = generateStaticLabel(totalNumRecs, isTiresTrailerPage)
  return {
    staticLabel
  }
})

const shouldViewUpdate = lifecycle({
  shouldComponentUpdate({ preventComponentUpdate }) {
    // Prevent component from updating if navigating away from search results. Fix for BOT-643
    return !preventComponentUpdate
  }
})

export default compose(
  withType({ type: 'BOTSearchResult', placeholders: ['leftContent', 'rightContent']}),
  connect(mapStateToProps, { resetFilters }),
  withStaticLabel,
  withTotalRecords,
  withCheckStoreAndShowStoreLocatorModal,
  withGBBDetails,
  shouldViewUpdate,
  withRecommendedResultsVisibilityProp,
  withNoResultComponent
)(BOTSearchResult)
